import type { RouteLocationNormalized } from '#vue-router'

export const useLoadWapersCornerCommunity = () => {
  const communitiesStore = useCommunitiesStore()
  const waperCornersStore = useWaperCornersStore()

  return async (route: RouteLocationNormalized) => {
    try {
      await Promise.all([
        // Fetch data about the community
        communitiesStore.fetchCommunity({
          slug: route.params.communityName as string,
        }),
        // Fetch post categories from the community
        waperCornersStore.fetchWaperCornersCommunitySubcategories(
          route.params.communityName as string,
        ),
        // Fetch posts `waperCorners` from the community subcategory
        waperCornersStore.fetchCommunityWaperCorners({
          page: getPageQuery(route),
          community: route.params.communityName as string,
        }),
      ])
    } catch (error) {
      console.error('from page', error)
    }

    throwIfNotFound(communitiesStore.community)

    if (waperCornersStore.getCommunityPagesCount === -1) {
      return navigateTo(route.path, { replace: true })
    }
  }
}
